import { ANALYTICS_SUBSCRIBE_BUTTON } from "@/src/common/business-layer/constants"
import { useAnalytics } from "@/src/sb/components/Analytics"
import { EventTrackOptions } from "@/src/sb/components/Analytics/AnalyticsAdapter"
import {
  UNCOMPLETED_PROFILE_DEMO_FORM_URL,
  V2_FEATURE_TOGGLES
} from "@/src/sb/constants/configs"
import { B2C_SUNSET } from "@/src/sb/constants/featureFlags"
import classNames from "classnames"
import { useRouter } from "next/router"
import React, { ReactNode } from "react"

import { pages } from "../../constants/copy"
import useRequestDemo from "../../hooks/useRequestDemo"
import Button from "../Button"
import Logo from "../Logo"
import MobileTopNavBar from "../Navigationbar"
import { SimpleLink } from "../SimpleLink"

type HeaderProps = {
  link?: {
    text: string
    href: string
  }
  hideHeaderLinks?: boolean
}

const Header = (props: HeaderProps) => {
  const { pathname } = useRouter()
  const requestDemo = useRequestDemo()

  const { link, hideHeaderLinks } = props
  const analytics = useAnalytics()
  const handleNavItemClick = (
    name: string,
    props: EventTrackOptions["eventProperties"]
  ) => {
    V2_FEATURE_TOGGLES.has(B2C_SUNSET)
      ? analytics?.clickCorporateQuote({ type: "get_licence" })
      : analytics?.clickNavItem(name, props)
  }

  const currentPageIsAuthPage =
    pages.signin.includes(pathname) || pages.signup.includes(pathname)
  return (
    <div>
      <div className="flex tablet:hidden portrait_tablet:hidden pt-4  justify-between items-center px-18 portrait_tablet:bg-stears_white tablet:bg-stears_white">
        <SimpleLink href={pages.landingPage} color="black">
          <Logo type="black" />
        </SimpleLink>

        {!hideHeaderLinks ? (
          <div>
            {link ? (
              <div className="inline-block mr-7">
                <SimpleLink href={link.href} color="black">
                  {link.text}
                </SimpleLink>
              </div>
            ) : null}

            <Button
              href={requestDemo.url}
              type="cta"
              onClick={() => {
                handleNavItemClick(ANALYTICS_SUBSCRIBE_BUTTON, {
                  context: "header"
                })
              }}
            >
              {V2_FEATURE_TOGGLES.has(B2C_SUNSET)
                ? "Request Demo"
                : "Subscribe"}
            </Button>
          </div>
        ) : null}
      </div>

      <div className="hidden tablet:block portrait_tablet:block mb-1">
        <MobileTopNavBar
          actionBtnType="cta"
          userType="anonymous"
          actionText={
            V2_FEATURE_TOGGLES.has(B2C_SUNSET) ? "Request Demo" : "Subscribe"
          }
          actionHref={
            V2_FEATURE_TOGGLES.has(B2C_SUNSET)
              ? UNCOMPLETED_PROFILE_DEMO_FORM_URL
              : currentPageIsAuthPage
              ? pages.subscriptions
              : undefined
          }
          onNavItemClick={handleNavItemClick}
        />
      </div>
    </div>
  )
}

type AuthLayoutProps = {
  children: ReactNode
  headerLink?: HeaderProps["link"]
  hideHeader?: boolean
  hideHeaderLinks?: boolean
}

export const AuthLayout = (props: AuthLayoutProps) => {
  const { children, headerLink, hideHeader, hideHeaderLinks } = props
  return (
    <div className="overflow-y-auto bg-gray-100 tablet:h-auto portrait_tablet:bg-stears_white tablet:bg-stears_white portrait_tablet:h-auto">
      {!hideHeader ? (
        <Header link={headerLink} hideHeaderLinks={hideHeaderLinks} />
      ) : null}

      <div
        className={classNames(
          "h-auto mobile:h-full  portrait_tablet:h-full flex justify-center items-center tablet:text-center portrait_tablet:text-center py-20",
          [hideHeader ? "min-h-[100vh]" : "min-h-[calc(100vh-78px)] mt-2"]
        )}
      >
        <div className="xl:min-w-[480px] portrait_tablet:max-w-[480px] portrait_tablet:w-full bg-stears_white py-10 px-12 portrait_tablet:px-4 rounded-2xl h-fit pb-14">
          {children}
        </div>
      </div>
    </div>
  )
}
